import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ReportChartComponent} from "../types/report.chart.component";
import {useAppStore} from "../../../common/app.store.consumer";

const PdfDownload: React.FC<ReportChartComponent> = useAppStore()(({isPdf: boolean, appStore}) => {
	const fileSize = appStore.reportPageStore.questionnaireAnswerSheetDetails.pdfDownload.fileSize;
	const downloadLink = appStore.reportPageStore.questionnaireAnswerSheetDetails.pdfDownload.downloadLink;

	const openDownloadLink = () => {
		let tempLink = document.createElement("a");
		tempLink.href = downloadLink;
		tempLink.click();
	};

	return (
		<div className="cih-download-bar">
			<div>
				<div className="download-title">My Professional Standards Report</div>
				<div className="download-details">{fileSize ? `PDF ${fileSize}kb` : "PDF generation is processing"}</div>
			</div>
			<button className="cih-btn-med cih-align-self-end cih-align-items-center cih-align-self-center" disabled={!downloadLink} onClick={openDownloadLink}>
				{!downloadLink ? <FontAwesomeIcon icon={["fas", "sync"]} spin /> : <FontAwesomeIcon icon={["fas", "arrow-down"]} />}
				Download
			</button>
		</div>
	);
});

export default PdfDownload;
